import { instance } from ".";

export const getCountryCodeList = async () => {
  const res = await instance.get("/v1/common/countryCodes");
  console.log("getCountryCodeList res: ", res?.data);
  return res?.data;
};
